import { api } from './client.js';

export const leaveApi = {
    getBalance: () => api.get('/api/v1/leave/balance'),
    getTypes: () => api.get('/api/v1/leave/types'),

    listMine: (params = {}) => {
        const q = new URLSearchParams();
        if (params.page) q.set('page', params.page);
        const qs = q.toString();
        return api.get(`/api/v1/leave/requests${qs ? '?' + qs : ''}`);
    },
    submit: (body) => api.post('/api/v1/leave/requests', body),
    cancel: (id) => api.post(`/api/v1/leave/requests/${id}/cancel`),

    listPending: () => api.get('/api/v1/leave/requests/pending'),
    approve: (id, body = {}) => api.post(`/api/v1/leave/requests/${id}/approve`, body),
    reject: (id, body) => api.post(`/api/v1/leave/requests/${id}/reject`, body),

    teamCalendar: () => api.get('/api/v1/leave/team-calendar'),
};
